import React, { Component } from 'react'
import { connect } from 'react-redux'

import ModalScreenLayout from 'navigation-ui/ModalScreenLayout'
import NavBar from 'components/NavBar'
import styles from './HomeNewsTagPage.css'

const Tag = ({ name }) => {
  return <div className={styles.tag}>{name}</div>
}

const HomeNewsTagPage = ({ tag, tabs, children }) => {
  return (
    <ModalScreenLayout
      className={styles.home_news_tag_page}
      left={[
        <Tag key="tag" name={tag} />,
        <NavBar
          key="navbar"
          className={styles.nav}
          tabs={tabs}
          showIcons={false}
        />
      ]}
    >
      {children}
    </ModalScreenLayout>
  )
}

const mapStateToProps = ({
  navigation: { secondary: tabs },
  location: { payload: { tag } }
}) => ({
  tag,
  tabs: tabs.map(t => ({ ...t, replace: true }))
})
const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(HomeNewsTagPage)
